import { Collection } from 'modules/core/lib/mobx-rest'
import Feature from 'modules/core/store/models/Feature'

export class Features extends Collection<Feature> {
  get cacheKey(): string {
    return 'features'
  }

  model() {
    return Feature
  }
}

const singleton: Features = new Features()

export default singleton
